const usePreventScroll = () => {
  const preventDefault = e => {
    const event = e || window.event;
    if (event.preventDefault) {
      event.preventDefault();
    }
    event.returnValue = false;
  };

  const enableScroll = () => {
    document.removeEventListener('wheel', preventDefault, false);
  };

  const disableScroll = () => {
    document.addEventListener('wheel', preventDefault, {
      passive: false,
    });
  };

  return {
    enableScroll,
    disableScroll,
  };
};

export default usePreventScroll;
